// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/workload_settings.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_workload_thresholds } from "./workload_thresholds_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/workload_settings.proto.
 */
export const file_studyo_today_schools_v1_resources_workload_settings = /*@__PURE__*/
  fileDesc("CjlzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvd29ya2xvYWRfc2V0dGluZ3MucHJvdG8SIXN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcyKYAQoQV29ya2xvYWRTZXR0aW5ncxIKCgJpZBgBIAEoCRIRCglzY2hvb2xfaWQYAiABKAkSEgoKc3luY190b2tlbhgDIAEoAxJRChJkZWZhdWx0X3RocmVzaG9sZHMYBCABKAsyNS5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuV29ya2xvYWRUaHJlc2hvbGRzQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z", [file_studyo_today_schools_v1_resources_workload_thresholds]);

/**
 * Describes the message studyo.today.schools.v1.resources.WorkloadSettings.
 * Use `create(WorkloadSettingsSchema)` to create a new message.
 */
export const WorkloadSettingsSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_workload_settings, 0);

